// extracted by mini-css-extract-plugin
export default {"bannerContainer":"index_snow_bannerContainer__M-9dr","bannerImage":"index_snow_bannerImage__dYTSf"};